<script>
    import { onMount } from 'svelte';
    import GanttHelper from './GanttHelper.js';
  
    export let Label;
    export let StartDate;
    export let EndDate;
    export let Height;
    export let OriginY;
    export let AdjustStamp;
    export let CurrentStyle;
    export let GanttStore;
  
    const { 
        GetAdjustedDateInclDaysOff 
    } = GanttStore;
  
    const fontSize = "14px";
    const lineHeight = "1.5";

    $: active = Label?._active ?? true;

    const toggleActivation = () => {
        Label._active = !(Label?._active ?? true);
    }
  
    const VAlign = {
      Top: "top",
      Center: "middle",
      Bottom: "bottom",
    };
  
    const HAlign = {
      Left: "start",
      Center: "center",
      Right: "end",
    };
  
    $: LabelContent = ((typeof Label._string === 'string') ? Label._string : ((CurrentStyle in Label._string) ? Label._string[CurrentStyle] : "")).replaceAll('\\n', '\n');
  
    const UnclampedCalculateStampX = (stamp) => 100 * GanttHelper._gantHelper_scale($GetAdjustedDateInclDaysOff(AdjustStamp(stamp)).getTime(), EndDate.getTime(), StartDate.getTime());
  
    let textEl;
  
    const updateSize = () => {
      if (textEl) {
        const bbox = textEl.getBoundingClientRect();
        Label._widthAdj = bbox.width;
        Label._heightAdj = bbox.height;
      }
    }

    $: LabelHeight = Label?._heightAdj ?? Label._height;
    $: LabelWidth = Label?._widthAdj ?? Label._width;
  
    onMount(() => {
      updateSize();
    });
  
    $: quadPoints = (() => {
      const x = Label._rectRelX;
      const y = Label._rectRelY;
      const w = LabelWidth;
      const h = LabelHeight;
  
      const isLeft = x < 0;
      const isTop = y < 0;
  
      if (!isLeft && !isTop) {
        return `${x},${y + h * 0.2} 0,0 ${x + w * 0.2},${y} ${x + w},${y} ${x + w},${y + h} ${x},${y + h}`;
      } else if (isLeft && !isTop) {
        if (-x > w)
          return `${w},${y + h * 0.2} ${-x},0 ${w * 0.8},${y} 0,${y} 0,${y + h} ${w},${y + h}`;
        else
          return `${w},${y} ${w * 0.6},${y} ${-x},0 ${w * 0.4},${y} 0,${y} 0,${y + h} ${w},${y + h}`;
      } else if (!isLeft && isTop) {
        if (-y > h)
          return `${x + w * 0.2},${h} 0,${-y} ${x},${h * 0.8} ${x},0 ${x + w},0 ${x + w},${h}`;
        else
          return `${x},${h} ${x},${h * 0.6} 0,${-y} ${x},${h * 0.4} ${x},0 ${x + w},0 ${x + w},${h}`;
      } else {
        if (-y > h && -x > w)
          return `${w * 0.8},${h} ${-x},${-y} ${w},${h * 0.8} ${w},0 0,0 0,${h}`;
        else if (-y <= h && -x > w)
          return `${w},${h} ${w},${h * 0.6} ${-x},${-y} ${w},${h * 0.4} ${w},0 0,0 0,${h}`;
        else if (-y > h && -x <= w)
          return `${w * 0.4},${h} ${-x},${-y} ${w * 0.6},${h} ${w},${h} ${w},0 0,0 0,${h}`;
        else
          return `${w},${h} ${w},0 0,0 0,${h}`;
      }
    })();
  </script>

  {#if active === true}
  
  <svg
    x="{Math.min(0, Label._rectRelX)}px"
    y="{Math.min(0, Label._rectRelY)}px"
    height="100%"
    width="100%"
    style="overflow: visible"
  >
    <svg
      id="{Label._objectID}"
      x="{UnclampedCalculateStampX(Label._timePoint)}%"
      y="{OriginY + Label._relYRatio * Height}%"
      height="{LabelHeight + Math.abs(Label._rectRelY)}px"
      width="{LabelWidth + Math.abs(Label._rectRelX)}px"
    >
      <polygon
        points="{quadPoints}"
        style="fill:{Label._backColor};stroke-width:1;stroke:{Label._borderColor};cursor:pointer;"
        on:click={() => toggleActivation()}
      />
      <foreignObject
        x="{Label._rectRelX < 0 ? 0 : Label._rectRelX}px"
        y="{Label._rectRelY < 0 ? 0 : Label._rectRelY}px"
        height="{LabelHeight}px"
        width="{LabelWidth}px"
        style="cursor:pointer;"
        on:click={() => toggleActivation()}
      >
        <div
          bind:this={textEl}
          style="
            display: table-cell;
            height: auto;
            width: auto;
            overflow: hidden;
            vertical-align: {VAlign[Label._textVerticalAlignment]};
            text-align: {HAlign[Label._textHorizontalAlignment]};
            color: {Label._textColor};
            padding: 2px;
            white-space: pre-line;
            font-size: {fontSize};
            line-height: {lineHeight};
            pointer-events:none;
          ">
          {LabelContent}
        </div>
      </foreignObject>
    </svg>
  </svg>

  {:else}

  <svg
    x="{UnclampedCalculateStampX(Label._timePoint)}%"
    y="{OriginY + Label._relYRatio * Height}%"
    height="50"
    width="50"
    style="overflow: visible"
  >
    <image
        href="/assets/icons/label_icon_bubble.svg"
        x="-4"
        y="-4"
        height="50px"
        width="50px"
        style="cursor:pointer;"
        on:click={() => toggleActivation()}
        >
        <title>{LabelContent}</title>
    </image>
  </svg>

  {/if}
  